module.exports = __webpack_public_path__ + "static/4-c006dacfd86310efaa91197ee885a779.png";